import React from "react";

const base = { viewBox: "0 0 64 76", fill: "none", stroke: "currentColor", strokeWidth: 1.4, strokeLinecap: "round", strokeLinejoin: "round" };

// ---------- Lapel (suit jacket) ----------
export function LapelIcon({ variant }) {
  const shapes = {
    notch: "M32 10 L14 20 L22 34 L32 22 L42 34 L50 20 Z",
    peak: "M32 10 L12 18 L24 30 L32 20 L40 30 L52 18 Z",
    shawl: "M32 10 Q16 16 16 34 L32 24 L48 34 Q48 16 32 10 Z",
  };
  return (
    <svg {...base}>
      <path d="M22 14 L18 70 M42 14 L46 70" />
      <path d={shapes[variant]} />
    </svg>
  );
}

// ---------- Vent (jacket back) ----------
export function VentIcon({ variant }) {
  return (
    <svg {...base}>
      <path d="M20 8 L18 70 L46 70 L44 8" />
      {variant === "single" && <path d="M32 50 L32 70" />}
      {variant === "double" && <><path d="M24 50 L24 70" /><path d="M40 50 L40 70" /></>}
      {variant === "none" && <path d="M18 70 L46 70" />}
    </svg>
  );
}

// ---------- Button stance ----------
export function ButtonStanceIcon({ variant }) {
  const counts = { "1": [38], "2": [32, 44], "3": [26, 36, 46] };
  const ys = counts[variant] || counts["2"];
  return (
    <svg {...base}>
      <path d="M26 6 L18 14 L24 26 L32 18 L40 26 L46 14 L38 6" />
      <path d="M22 14 L20 70 M42 14 L44 70" />
      {ys.map((y) => <circle key={y} cx="32" cy={y} r="1.6" fill="currentColor" />)}
    </svg>
  );
}

// ---------- Jacket pocket ----------
export function JacketPocketIcon({ variant }) {
  if (variant === "jetted") {
    return (
      <svg {...base}>
        <path d="M14 40 L30 38 M34 38 L50 40" />
      </svg>
    );
  }
  if (variant === "patch") {
    return (
      <svg {...base}>
        <rect x="16" y="32" width="16" height="18" />
      </svg>
    );
  }
  // flap
  return (
    <svg {...base}>
      <rect x="16" y="36" width="16" height="8" />
      <path d="M16 36 L14 32 L34 32 L32 36" />
    </svg>
  );
}

// ---------- Pleats (trouser front) ----------
export function PleatIcon({ variant }) {
  const lines = { flat: [], single: [32], double: [28, 36] };
  return (
    <svg {...base}>
      <rect x="16" y="8" width="32" height="10" />
      <path d="M18 18 L14 70 M46 18 L50 70" />
      {(lines[variant] || []).map((x) => <path key={x} d={`M${x} 18 L${x} 60`} />)}
    </svg>
  );
}

// ---------- Hem (trouser bottom) ----------
export function HemIcon({ variant }) {
  const cuffed = variant === "cuffed";
  return (
    <svg {...base}>
      <path d="M22 8 L18 60 M42 8 L46 60" />
      {cuffed ? (
        <>
          <path d="M18 60 L46 60" />
          <rect x="17" y="60" width="30" height="8" />
        </>
      ) : (
        <path d="M18 60 L46 60" />
      )}
    </svg>
  );
}

// ---------- Trouser fit ----------
export function TrouserFitIcon({ variant }) {
  const legs = {
    slim: "M24 8 L21 70 M40 8 L43 70",
    regular: "M22 8 L20 70 M42 8 L44 70",
    relaxed: "M20 8 L17 70 M44 8 L47 70",
  };
  return (
    <svg {...base}>
      <rect x="18" y="4" width="28" height="10" />
      <path d={legs[variant]} />
      <path d="M32 8 L31 45" strokeDasharray="2 3" opacity="0.5" />
    </svg>
  );
}

// ---------- Trouser pocket ----------
export function TrouserPocketIcon({ variant }) {
  if (variant === "coin") {
    return (
      <svg {...base}>
        <path d="M20 10 Q30 16 26 26" />
        <rect x="34" y="10" width="8" height="8" />
      </svg>
    );
  }
  return (
    <svg {...base}>
      <path d={variant === "slant" ? "M18 10 Q30 16 28 28" : "M22 8 L22 26"} />
    </svg>
  );
}

// ---------- Waistband ----------
export function WaistbandIcon({ variant }) {
  return (
    <svg {...base}>
      <rect x="14" y="20" width="36" height="10" strokeDasharray={variant === "elastic" ? "3 3" : "0"} />
      {variant === "extended" && <rect x="10" y="20" width="8" height="10" />}
      <circle cx="32" cy="25" r="1.4" fill="currentColor" />
    </svg>
  );
}
